import { Box, TextField } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import React from 'react'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField readOnly required {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function DatePicker({ value, onChange, disabled }) {
    return (
        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
            <MobileDatePicker
                disabled={disabled}
                dayOfWeekFormatter={(day) => `${day}`}
                value={value} onChange={onChange}
                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: value } }}
                slots={{
                    textField: BrowserInput,
                }}
            />
        </Box>
    )
}
